import React, { useState } from "react";
import { Button, Divider, Table, Tag, Upload, message } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import readXlsxFile from 'read-excel-file';
import { gql, useMutation } from "@apollo/client";
import { error, success } from "../../Controllers/toast";
import findPlantId from "../../Controllers/findPlantId";


const { Dragger } = Upload;




const UploadList = (props) => {

  const data = []

  const plant_id = parseInt(findPlantId())
  // console.log(tableData, plant_id)
  const checkStatus = (status) => {
    switch (status) {
      case "active":
        return <Tag color="green">فعال شد</Tag>
      case "ASSIGNED":
        return <Tag color="red">تکراری</Tag>
      case "UNKNOWN":
        return <Tag color="gold">ناشناس</Tag>
      default:
        return <Tag color="default">نامشخص</Tag>
    }
  }
  return (
    <div>
      <input id="upload" type="file" name="files[]" onChange={e => {
        const input = document.getElementById('upload')
        // console.log(input.files[0])
        readXlsxFile(input.files[0]).then((rows) => {
          // console.log(rows)
          const serial_number_col_numb = (rows[0].map(cell => cell !== null ? (cell.toLowerCase().includes("s")) : false)).findIndex(e => e === true)
          const batch_number_col_numb = (rows[0].map(cell => cell !== null ? (cell.toLowerCase().includes("batch")) : false)).findIndex(e => e === true)
          // console.log(serial_number_col_numb, batch_number_col_numb);
          rows.map(row => {
            data.push({ serial_number: row[serial_number_col_numb], batch_number: row[batch_number_col_numb] })
          })
          data.shift()
          // setTableData(data);
          // `rows` is an array of rows
          // each row being an array of cells.

        })


      }}
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      >

      </input>
      <p className="ant-upload-text">
        برای بارگذاری، فایل خود را به اینجا بکشید یا کلیک کنید.
      </p>
      <p className="ant-upload-hint">
        شما تنها می توانید از فایلی با فرمت .xlsx , .cms استفاده کنید.
      </p>
      <div className="text-center">
        <Button block color="primary" type="primary" onClick={() => {
          props.assignGateway({
            variables: {
              plant_id,
              gatewayDevicesInput: {
                devices: data
              }
            }
          })
        }}>ارسال فایل</Button>
      </div>
      <Divider >لیست دستگاه های ورودی</Divider>
      <Table
        columns={[
          { title: "Serial Number", dataIndex: "serial_number", key: "sn" },
          { title: "Batch Number", dataIndex: "batch_number", key: "bn" },
          { title: "وضعیت", dataIndex: "status", render: (value) => checkStatus(value) }
        ]}
        dataSource={props.tableData}
        rowKey={record => record.serial_number}
      />
    </div>
  );
};

export default UploadList;
